import R from 'ramda';
import { defaultDoctypeResults } from '../reducers/search';
import { createSelector } from 'reselect';
import deprecated from '../deprecated';

import { param } from './utils';

const selectSearchRoot = root => root.search;

export const getCriteria = createSelector(
    selectSearchRoot,
    state => state.criteria
);

export const isLoading = createSelector(
    selectSearchRoot,
    state => {
        const { doctypes } = state;

        return !R.has('content', doctypes) || !R.has('markup', doctypes);
    }
);

export const _getDoctype = createSelector(
    selectSearchRoot,
    param(1),
    (state, doctype) => {
        return R.pathOr(defaultDoctypeResults, ['doctypes', doctype], state);
    }
);

export const selectTotal = createSelector(
    _getDoctype,
    tmp => tmp.meta.total_count
);
export const getTotal = deprecated(selectTotal, `use selectTotal instead`);

export const selectResults = createSelector(
    _getDoctype,
    tmp => tmp.results
);
export const getResults = deprecated(
    selectResults,
    `use selectResults instead`
);

export const selectNext = createSelector(
    _getDoctype,
    tmp => tmp.meta.next
);
export const getNext = deprecated(selectNext, `Use selectNext instead`);



// WEBPACK FOOTER //
// ./src/selectors/search.js